import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {setPullablePartDragging} from 'actions/index.js';

const PullablePart = (props) => { 
    const onDragStart = useCallback((e) => {
        let {effect, instrument} = props;
        let part = {
            instrument,
            effect,
            id: (instrument || effect).id,
            type: props.type
        };
        if (instrument && instrument.track) {
            part.track = instrument.track;
        } else if (effect) {
            part.track = effect.track;
        }
        props.setPullablePartDragging(part);
    }, []);
 
    return (
        <div
          onMouseDown={(e) => e.stopPropagation()}
          draggable="true"
          onDragStart={onDragStart}
          onDragOver={(e) => {
              e.preventDefault();
          }}
          className={props.className}>
          <div>
            {props.children}
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPullablePartDragging: x => dispatch(setPullablePartDragging(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PullablePart);
